import React, {useEffect, useState} from 'react';

import { useParams } from 'react-router-dom';
import { addUserToGroup } from './GroupService';
import { getUsersByAccount } from '../Users/UserService';


import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// import listGroupUsers from './GroupUserList';

const AttachUser = ({ listGroupUsers }) => {

  const [open, setOpen] = useState(false);
  // const [users, setUsers] = useState([])
  const [users, setUsers] = useState([]);
  // const navigate = useNavigate();


  // const [firstName, setFirstName] = useState('');
  // const [status, setStatus] = useState('');
  // const [startDate, setStartDate] = useState('')
  // const [endDate, setEndDate] = useState('')

  const [selectedUserId, setSelectedUserId] = useState(null); // State to hold the selected user ID

  const { accountid } = useParams();
  // const { userid } = useParams()
  const { groupid } = useParams();
  // const handleChange = (event) => {
  //     //setName(Number(event.target.value) || '');
  // };

  const handleChange = (userid) => {
    setSelectedUserId(userid); // Update the selected user ID when the user is changed
  };
  
  const handleClickOpen = () => {
    listUsersByAccount();
    setOpen(true);
  };
  
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  useEffect(() => {
    listUsersByAccount();
  }, []);

  function listUsersByAccount(){
      
    getUsersByAccount(accountid).then((response) => {
      setUsers(response.data);
    }).catch(error => {
      console.error(error);
    });
  }

  function attachSelectedUser(userid, groupid){

    //const user = {firstName, status};

    addUserToGroup(accountid, groupid, userid).then(() => {
      // appProgrammeList();
      listGroupUsers();
      handleClose();
    }).catch(error => {
      console.error(error);
    });
  }

  return (
    <div>
      <Button onClick={handleClickOpen}>Select User</Button>
      <Dialog disableEscapeKeyDown open={open} >
        <DialogTitle>Select</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              {/* <InputLabel htmlFor="demo-dialog-native">Name</InputLabel> */}
              <Select
                native
                value={selectedUserId || ''} // Use selectedAppId as the value
                onChange={(e) => handleChange(e.target.value)}
                input={<OutlinedInput label="Select User" id="demo-dialog-native" />}
              >
                {/* Ensure "Select Item" option is selected by default */}
                <option value={''} disabled>
                        Select User
                </option>
                {/* Map over items to generate options */}
                {users.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.firstName}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={addProgrammeAssignment(progid, selectedProgrammeId)}>Add</Button> */}
          <Button onClick={handleClose}>Cancel</Button> 
          <Button onClick={() => attachSelectedUser(selectedUserId, groupid)}>Add</Button>
        </DialogActions>
      </Dialog>
    </div>);
};

export default AttachUser;